import { ActionIcon, Indicator, Popover } from '@mantine/core';
import { useState } from 'react';
import { FaBell } from 'react-icons/fa';

import { useNotifications } from '../../../hooks/useNotifications';

import NotificationPanel from './NotificationPanel';

export const NotificationIcon = () => {
  const [opened, setOpened] = useState(false);
  const { unreadCount, refreshNotifications } = useNotifications();

  const toggleOpened = () => {
    const newState = !opened;
    setOpened(newState);

    // Force refresh notifications when opening the panel
    if (newState) {
      refreshNotifications();
    }
  };

  const closePanel = () => setOpened(false);

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      width={350}
      position="bottom-end"
      shadow="md"
      styles={{
        dropdown: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 'var(--mantine-radius-md)',
        },
      }}
      onOpen={() => refreshNotifications()}
    >
      <Popover.Target>
        <Indicator
          disabled={unreadCount === 0}
          processing
          size={10}
          offset={4}
          position="top-end"
          color="red"
          withBorder
          aria-label={`${unreadCount} unread notifications`}
        >
          <ActionIcon
            onClick={toggleOpened}
            variant={opened ? 'filled' : 'subtle'}
            color={opened ? 'blue' : 'gray'}
            size="lg"
            radius="xl"
            aria-label="Notifications"
          >
            <FaBell size={20} />
          </ActionIcon>
        </Indicator>
      </Popover.Target>

      <Popover.Dropdown>
        <NotificationPanel onClose={closePanel} />
      </Popover.Dropdown>
    </Popover>
  );
};
